import React from 'react';
import styles from './index.module.scss';

const NotAllowedScreen = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <p className={styles.text}>
          Даний контент призначений лише для повнолітніх осіб
        </p>
      </div>
    </div>
  );
};

export default NotAllowedScreen;
